import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/AILabelOutline.svg';

export const IconAILabelOutline = createIconComponent(Icon);
